const langIt = {
  "dm-header.back.text": "Torna alla sezione magazine",
};

export default langIt;
